<template>
	<div id="app" style="height: 100%">
		<router-view />
		<!-- <div class="page-mouthModal" v-show="visible">
      <div class="content">
        <div class="title">提示！</div>
        <div class="text">
          <p>{{ visibleName }}</p>
        </div>
        <div class="footer">
          <button @click="handleOk">确定</button>
        </div>
      </div>
    </div> -->
	</div>
</template>

<script>
	import {
		mapState,
		mapMutations
	} from "vuex";
	import {
		submitSlideAnswer,
		submitPetAnswer
	} from "@/api/system/exam";

	export default {
		data() {
			return {
				visibleName: "",
				visible: false,
				timesMicroscope: null,
				timesTreat: null,
				// 0显微镜  1考核
				activeIndex: 1,
				activeRoute: null,
			};
		},
		computed: {
			...mapState("visualExamination", [
				//步骤二
				"detail",
				//步骤三
				"detailsz2",
				//步骤四
				"detail3",
				"detailstepPre3",
				//步骤五
				"detail4",
				//步骤六
				"detail5",
				//倒计时
				"treatModleTime",
			]),
			...mapState("microscope", [
				"slidePaper",
				"detail1",
				"detail2",
				"microscopeModleTime",
			]),
		},

		mounted() {},
		//页面销毁时，取消监听。否则其他vue路由页面也会被监听
		beforeDestroy() {},
		watch: {
			// microscopeModleTime: {
			//   handler(val) {
			//     if (val) {
			//       this.setTimeMicroscope();
			//     } else if (!val) {
			//       clearInterval(this.timesMicroscope);
			//     }
			//   },
			// },
			// treatModleTime: {
			//   handler(val) {
			//     if (val) {
			//       this.setTimeTreat();
			//     } else if (!val) {
			//       clearInterval(this.timesTreat);
			//     }
			//   },
			// },
		},
		destroyed() {},
		methods: {
			...mapMutations("microscope", ["handleMicroscope"]),

			//关闭弹框
			// handleOk() {
			//   this.visible = false;
			//   if (this.activeIndex === 1) {
			//     let data = {
			//       paper1Id: this.slidePaper[0].id,
			//       paper2Id: this.slidePaper[1].id,
			//       detail1: this.detail1,
			//       detail2: this.detail2,
			//     };
			//     submitSlideAnswer(data).then((res) => {
			//       if (res.data.code === 0) {
			//         this.activeIndex = null;
			//         this.$router.push("/microscope/results");
			//       }
			//     });
			//   } else if (this.activeIndex === 3) {
			//     //每一步骤的最后答题结果
			//     const treatmentLists = JSON.parse(
			//       sessionStorage.getItem("treatmentList")
			//     );

			//     let newArr = [
			//       ...this.detail,
			//       ...this.detailsz2,
			//       ...this.detail3,
			//       ...this.detailstepPre3,
			//       ...this.detail4,
			//       ...this.detail5,
			//     ];
			//     newArr = newArr.filter((v) => v !== []);
			//     const parmes = {
			//       paperId: treatmentLists.id,
			//       details: newArr,
			//     };
			//     submitPetAnswer(parmes).then((res) => {
			//       if (res.data.code === 0) {
			//         this.$router.push("/treat/examineResult");
			//       }
			//     });
			//   }
			// },

			// // 显微镜计时
			// setTimeMicroscope() {
			//   // let timeNum = 1200;
			//   this.timesMicroscope = setInterval(() => {
			//     this.microscopeTimeNum--;
			//     this.handleMicroscope({
			//       key: "microscopeTimeNum",
			//       value: this.microscopeTimeNum,
			//     });
			//     if (this.microscopeTimeNum === 300) {
			//       this.visibleName =
			//         "距离考核结束还有5分钟，请尽快完成考题，避免影响最终成绩。";
			//       this.visible = true;
			//       this.activeIndex = 0;
			//     } else if (this.microscopeTimeNum === 0) {
			//       this.visibleName = '考试时间已结束，点击"确定"获得成绩。';
			//       this.visible = true;
			//       this.activeIndex = 1;
			//       clearInterval(this.timesMicroscope);
			//     }
			//   }, 1000);
			// },

			// // 考核镜计时
			// setTimeTreat() {
			//   let timeNum = 1200;
			//   this.timesTreat = setInterval(() => {
			//     timeNum--;
			//     if (timeNum === 300) {
			//       this.visibleName =
			//         "距离考核结束还有5分钟，请尽快完成考题，避免影响最终成绩。";
			//       this.visible = true;
			//       this.activeIndex = 2;
			//     } else if (timeNum === 0) {
			//       this.visibleName = '考试时间已结束，点击"确定"获得成绩。';
			//       this.visible = true;
			//       this.activeIndex = 3;
			//       clearInterval(this.timesTreat);
			//     }
			//   }, 1000);
			// },
		},
	};
</script>

<style lang="less" scoped>
	#app {
		width: 100%;
		position: relative;

		.page-mouthModal {
			width: 100%;
			min-height: 100vh;
			position: absolute;
			left: 0;
			top: 0;
			background: rgba(#fff, 0.8);
			display: flex;
			align-items: center;
			z-index: 9999;
			padding: 0px 40px;
			box-sizing: border-box;

			.content {
				width: 100%;
				height: 642px;
				z-index: 999;
				background: #ffffff;
				background: rgba(255, 255, 255, 0.9);
				border: 2px solid #ffffff;
				border-radius: 60px;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				// padding-top: 90px;
				// padding-bottom: 77px;
			}

			.title {
				font-size: 65px;
				font-family: HarmonyOS Sans SC;
				font-weight: bold;
				color: #ab3b91;
			}

			.text {
				font-size: 35px;
				font-family: HarmonyOS Sans SC;
				font-weight: bold;
				color: #333333;
				line-height: 60px;
				margin-top: 80px;
				text-align: center;
			}

			.footer {
				margin-top: 110px;

				button {
					width: 262px;
					height: 79px;
					background: linear-gradient(90deg, #1e3c72, #2a5298);
					border: 1px solid #ffffff;
					box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
					text-align: center;
					font-size: 35px;
					font-family: HarmonyOS Sans SC;
					font-weight: 500;
					color: #ffffff;
					line-height: 60px;
					letter-spacing: 2px;
					border-radius: 40px;
				}

				button:nth-child(2) {
					margin-left: 42px;
				}
			}
		}
	}
</style>